export const coreOnboardingProgressName = 'CoreOnboardingProgress';
